import { createStyles } from '@material-ui/core/styles';

export const styles = () =>
  createStyles({
    root: {},
    logo: {
      cursor: 'pointer',
      display: 'block',
      height: 35,
      width: 100,
    },
  });
